// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-048862d8] .el-cascader__search-input {\n  background: #FFF;\n}", ""]);
// Exports
module.exports = exports;
